import { Max } from "@pdfking/math"
import { Reduce } from "@pdfking/tfunc"

import type { FolderCorner, FolderShape } from "#internal"

import { FolderSame } from "./FolderSame"

/** The parts of a die, corners and shapes, one after the other round its
 * outline: a corner where two meet is kept once, as round as the rounder. */
export const FolderChain = (...parts: (FolderShape | FolderCorner)[]): FolderShape => {
  const shapes = parts.map(part =>
    "corners" in part ? part : { corners: [part], cut: [], fold: [] }
  )
  const corners = Reduce<FolderCorner, FolderCorner[]>(
    (chain, corner) => {
      const last = chain[chain.length - 1]
      return last && FolderSame(last, corner)
        ? [...chain.slice(0, -1), { ...last, radius: Max(last.radius, corner.radius) }]
        : [...chain, corner]
    },
    shapes.flatMap(shape => shape.corners),
    []
  )
  return {
    corners,
    cut: shapes.flatMap(shape => shape.cut),
    fold: shapes.flatMap(shape => shape.fold),
  }
}
